export default "__VITE_ASSET__3a6sW2PV__"